import { effects, trackingGA4 } from 'core/middlewares';
import { utilities } from 'core/use-cases';

import { persistedReducer, clearDataPersist } from './config';

function initStore() {
  const middlewares = [effects.middleware, trackingGA4.middleware, clearDataPersist];

  const store = utilities.configureStore({
    reducer: persistedReducer,
    middleware: middlewares,
    devTools: process.env.REACT_APP_ENV !== 'production',
  });

  effects.init();

  return {
    persistor: utilities.persistStore(store),
    store,
  };
}

const { persistor, store } = initStore();

export { persistor, store };
